import axios from 'axios';

const API_BASE_URL = '/api/v1/logger';

interface LogRequest {
  level: 'error' | 'warn' | 'info' | 'debug';
  message: string;
  notes?: any;
  context?: {
    component?: string;
    userAgent?: string;
    url?: string;
    timestamp?: string;
  };
}

export const LoggerService = {
  log: async (request: LogRequest): Promise<void> => {
    try {
      await axios.post(`${API_BASE_URL}/log`, request);
    } catch (error) {
      console.error('Failed to send log to backend:', error);
    }
  },

  error: (message: string, notes?: any, component?: string) => 
    LoggerService.log({
      level: 'error',
      message,
      notes,
      context: { component, userAgent: navigator.userAgent, url: window.location.href, timestamp: new Date().toISOString() }
    }),

  warn: (message: string, notes?: any, component?: string) => 
    LoggerService.log({
      level: 'warn',
      message,
      notes,
      context: { component, userAgent: navigator.userAgent, url: window.location.href, timestamp: new Date().toISOString() }
    }),

  info: (message: string, notes?: any, component?: string) => 
    LoggerService.log({
      level: 'info',
      message,
      notes,
      context: { component, userAgent: navigator.userAgent, url: window.location.href, timestamp: new Date().toISOString() }
    }),

  debug: (message: string, notes?: any, component?: string) => 
    LoggerService.log({
      level: 'debug',
      message,
      notes,
      context: { component, userAgent: navigator.userAgent, url: window.location.href, timestamp: new Date().toISOString() }
    })
};